
/**
 * Agregar product_id y company_id al filtro
 */
export function setDataFilter(state, {product_id, company_id}) {
    state.filter.product_id = product_id;
    state.filter.company_id = company_id;
}

/**
 * Setear un adjunto
 */
export function setAttachments(state, attachments) {
    state.attachments = attachments
}

/**
 * Actualizar un adjunto
 */
export function updateAdjunto(state, adjuntUpdated) {
    const index = state.attachments.data.findIndex(item => item.id == adjuntUpdated.id);
    state.attachments.data.splice(index, 1, adjuntUpdated)
}

/**
 * Cambiar la pagina paginacion
 */
export function changePerPage(state, per_page) {
    state.filter.per_page = per_page;

}

/**
 * Limpiar el filtro
 */
export function clearFilter(state, company_id) {
    state.filter = {
        company_id,
        order: null,
        state: null,
        from: null,
        to: null,
        page: 1,
        per_page: 10,
        sortBy: 'id',
        sort: 'DESC',
    }
}





